import styled from 'styled-components'

const SecondLevelTitle = styled.h2`
  font-size: 18px;
`

export default SecondLevelTitle
